import { media } from 'styled-bootstrap-grid';
import styled from 'styled-components';

export const ClassFiltersWrapper = styled.div`
  display: flex;
  flex-direction: column;
  padding: 5px 0;
  height: calc(100% - 50px);

  ${media.md`
    flex-direction: row;
    margin: 0 -10px;
    align-items: flex-end;
    height: initial;
  `}
`;

export const ClassFiltersColumn = styled.div`
  margin-bottom: 20px;

  ${media.md`
    padding: 0 10px;
    border-bottom: none;
    margin-bottom: 0;
  `}
`;

export const ButtonClassFiltersColumn = styled(ClassFiltersColumn)`
  padding-top: 10px;
  width: 100%;
  border-bottom: none;

  ${media.md`
    padding-top: 0px;
    height: 46px;
  `};
`;

export const FiltersWrapper = styled.div`
  width: 100%;
  display: flex;
  flex-direction: column;
`;
